import { auth } from '../firebase';

export interface FirestoreErrorInfo {
  error: string;
  operationType: 'create' | 'update' | 'delete' | 'list' | 'get' | 'write' | 'watch';
  path: string | null;
  authInfo: {
    userId: string | undefined;
    email: string | null | undefined;
    emailVerified: boolean | undefined;
    isAnonymous: boolean | undefined;
    tenantId: string | null | undefined;
    providerInfo: {
      providerId: string;
      displayName: string | null;
      email: string | null;
      photoUrl: string | null;
    }[];
  }
}

export function handleFirestoreError(error: unknown, operationType: FirestoreErrorInfo['operationType'], path: string | null) {
  const errInfo: FirestoreErrorInfo = {
    error: error instanceof Error ? error.message : String(error),
    authInfo: {
      userId: auth.currentUser?.uid,
      email: auth.currentUser?.email,
      emailVerified: auth.currentUser?.emailVerified,
      isAnonymous: auth.currentUser?.isAnonymous,
      tenantId: auth.currentUser?.tenantId,
      providerInfo: auth.currentUser?.providerData.map(provider => ({
        providerId: provider.providerId,
        displayName: provider.displayName,
        email: provider.email,
        photoUrl: provider.photoURL
      })) || []
    },
    operationType,
    path
  };
  
  const errorString = JSON.stringify(errInfo);
  console.error('Firestore Error Payload:', errorString);
  
  // Specific handling for common errors
  const message = error instanceof Error ? error.message : String(error);
  if (message.includes('insufficient permissions') || message.includes('permission-denied')) {
     return "Missing or insufficient permissions. Please check security rules.";
  }

  if (message.includes('quota-exceeded') || message.includes('resource-exhausted') || message.includes('Quota limit exceeded')) {
    return "The system has reached its daily database capacity (Firestore Quota Exceeded). This limit resets every 24 hours at midnight US Central Time (06:00 UTC).";
  }
  
  return message;
}
